import React from 'react';
import { AI_DIFFICULTIES } from '../constants/gameConstants';

const DifficultySelector = ({ currentDifficulty, onDifficultyChange }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '8px'
    }}>
      {AI_DIFFICULTIES.map((level) => {
        const isSelected = currentDifficulty === level.id;
        return (
          <button
            key={level.id}
            onClick={() => onDifficultyChange(level.id)}
            style={{
              padding: '8px 12px',
              backgroundColor: isSelected ? '#4CAF50' : '#f0f0f0',
              color: isSelected ? 'white' : 'black',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              minWidth: '90px',
              boxShadow: isSelected ? '0 2px 4px rgba(0,0,0,0.2)' : 'none'
            }}
          >
            {level.label}
          </button>
        );
      })}
    </div>
  );
};

export default DifficultySelector;

